(function ($) {
  'use strict';

  // Variáveis
  const $form = $('#form-cadastro');
  const $btnSubmit = $('#cadastrar-conta');
  const $formCadastroInputs = $('.form-cadastro-init');
  const $formTit = $('.pag-login-title');
  const $campoEmail = $form.find('#email');
  const $verifyCodeWrp = $('.verification-code-wrp');
  const $resendTxt = $('.mdl-resend-txt');
  const $resendLink = $('.mdl-resend-link');
  const $validateBtn = $('.mdl-btn');
  const urlVerifica = urlBase + 'core/acoes/app/acesso/verificacao.php';
  let btnSubmitTxt = $btnSubmit.html();
  let formTitTxt = $formTit.html();
  let sending = false;
  let resendTimer;
  let resendSeconds = 60;
  let resendCountdown = resendSeconds;

  if ($form.length) {
    // Envia o formulário
    $form.on('submit', function (ev) {
      ev.preventDefault();
      submitFormInitial();
    });

    // Fix para os campos com validação remota
    $form.find('[data-parsley-remote]').each(function () {
      $(this)
        .parsley()
        .on('field:validate', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', true);
          }
        })
        .on('field:validated', function () {
          if (!sending) {
            $btnSubmit.prop('disabled', false);
          }
        });
    });
    /* $btnSubmit.on('click', function (ev) {
      ev.preventDefault();
      $form
        .parsley()
        .whenValidate()
        .done(function () {
          submitFormInitial();
        });
    }); */

    // Ao clicar para solicitar um novo código
    $resendLink.on('click', 'a', function (ev) {
      ev.preventDefault();
      sendVerification();
    });

    // Ao clicar no botão para validar o código
    $validateBtn.on('click', function (ev) {
      ev.preventDefault();
      validateCode();
    });

    // Envia o formulário inicial para validação de e-mail
    function submitFormInitial() {
      if (getUrlParam('ellos')) {
        registerAccount();
      } else {
        sendVerification();
      }
    }

    // Configura a animação de cadastro
    if ($('.loader-cad-animation').length > 0) {
      const $animation = $('.loader-cad-animation');
      const animation = bodymovin.loadAnimation({
        container: $animation[0],
        renderer: 'svg',
        loop: true,
        autoplay: true,
        prerender: true,
        path: $animation.data('json'),
      });
    }

    // Exibe o animação de cadastro
    function showLoaderCad() {
      $('#loader-cad').addClass('active');
    }

    // Oculta o animação de cadastro
    function hideLoaderCad() {
      $('#loader-cad').removeClass('active');
    }

    // Exibe a confirmação de e-mail
    function showVerification() {
      $formCadastroInputs.hide();
      $formTit.text('Confirme seu e-mail!');
      $verifyCodeWrp.removeClass('d-none');
    }

    // Oculta a confirmação de e-mail
    function hideVerification() {
      $verifyCodeWrp.addClass('d-none');
      $formCadastroInputs.show();
      $formTit.text(formTitTxt);
      if (resendTimer) {
        clearInterval(resendTimer);
        resendCountdown = resendSeconds;
      }
    }

    // Envia o código de verificação
    function sendVerification() {
      let email = $campoEmail.val().trim();
      const data = {
        acao: 'verifica_email',
        email: email,
      };
      $('.v-mail').text(email);
      $resendTxt.find('b').text(resendSeconds);
      $resendLink.hide();
      $resendTxt.show();
      showLoader();
      $.getJSON(urlVerifica, data, function (result) {
        console.log(result);
        hideLoader();
        if (result && result.status === 'success') {
          $('.verification-code input').val('');
          showVerification();
          setTimeout(() => {
            $('.verification-code input').first().focus();
          }, 100);
          resendTimer = setInterval(() => {
            resendCountdown--;
            $resendTxt.find('b').text(resendCountdown);
            if (resendCountdown === 0) {
              clearInterval(resendTimer);
              resendCountdown = resendSeconds;
              $resendTxt.hide();
              $resendLink.show();
            }
          }, 1000);
        } else {
          Toast.fire({
            type: 'error',
            title: 'Não foi possível verificar o e-mail.',
          });
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível verificar o e-mail.',
        });
      });
    }

    // Obtém o código informado
    function getVerificationCode() {
      let code = '';
      $('.verification-code input').each(function () {
        code += $(this).val();
      });
      if (code.length === 5) {
        return code;
      }
      return false;
    }

    // Valida o codigo
    function validateCode() {
      const code = getVerificationCode();
      if (!code) {
        Toast.fire({
          type: 'warning',
          title: 'Informe o código de verificação completo.',
        });
        return false;
      }
      const data = {
        acao: 'verifica_codigo',
        code: code,
        email: $campoEmail.val().trim(),
      };
      showLoader();
      $.getJSON(urlVerifica, data, function (result) {
        console.log(result);
        if (result && result.status === 'success') {
          hideLoader();
          registerAccount();
        } else {
          hideLoader();
          $('.verification-code input').val('');
          setTimeout(() => {
            $('.verification-code input').first().focus();
          }, 100);
          Toast.fire({
            type: 'error',
            title: 'Código de verificação inválido!',
          });
        }
      }).fail(function (qXHR, textStatus, errorThrown) {
        console.log(qXHR);
        hideLoader();
        Toast.fire({
          type: 'error',
          title: 'Não foi possível validar o código.',
        });
      });
    }

    // Realiza o cadastro
    function registerAccount() {
      if (!sending) {
        // Verifica se tem recaptcha e adiciona o token
        if (
          $form.hasClass('enable-recaptcha') &&
          typeof grecaptcha !== 'undefined' &&
          typeof recaptchaKey !== 'undefined'
        ) {
          recaptchaGenerateToken(
            $form,
            function () {
              $('input[name="confirmed_mail"]').val('1');
              const obj = $form[0];
              const dados = new FormData(obj);
              hideVerification();
              beforeSend();
              $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data: dados,
                contentType: false,
                processData: false,
                success: function (data) {
                  successSend(data);
                },
                error: function (xhr, type, exception) {
                  errorSend(xhr);
                },
              });
            },
            resetSend,
          );
        }
      }
    }

    // Enquanto a conta está sendo criada
    function beforeSend() {
      sending = true;
      $btnSubmit.prop('disabled', true);
      $btnSubmit.html('<div class="btn-spinner"></div> Aguarde');
      showLoaderCad();
    }

    // Reseta o formulário
    function resetSend() {
      $btnSubmit.prop('disabled', false);
      $btnSubmit.html(btnSubmitTxt);
      sending = false;
      hideLoaderCad();
    }

    // Cadastro realizado com sucesso
    function successSend(data) {
      console.log(data);
      const resp = JSON.parse(data);
      if (resp.status === 'success') {
        Toast.fire({
          type: 'success',
          title: resp.message,
        });
        setTimeout(() => {
          location.href = $('#retorno_success').val();
        }, 1000);
      } else {
        resetSend();
        Toast.fire({
          type: 'error',
          title: resp.message,
        });
      }
    }

    // Erro do envio
    function errorSend(resp) {
      console.log(resp);
      resetSend();
      Toast.fire({
        type: 'error',
        title: 'Não foi possível criar a sua conta.',
      });
    }
  }
})(jQuery);

// Campo de verificação de código
(function () {
  'use strict';
  if ($('.verification-code').length) {
    // Variáveis
    const $verificatioWrp = $('.verification-code');
    const inputs = $verificatioWrp[0].querySelectorAll('input');
    const KEYBOARDS = {
      backspace: 8,
      arrowLeft: 37,
      arrowRight: 39,
    };

    function handleInput(e) {
      const input = e.target;
      const nextInput = input.nextElementSibling;
      if (nextInput && input.value) {
        nextInput.focus();
        if (nextInput.value) {
          nextInput.select();
        }
      }
    }

    function handlePaste(e) {
      e.preventDefault();
      const paste = e.clipboardData.getData('text');
      inputs.forEach((input, i) => {
        input.value = paste[i] || '';
      });
    }

    function handleBackspace(e) {
      const input = e.target;
      if (input.value) {
        input.value = '';
        return;
      }

      if (input.previousElementSibling) {
        input.previousElementSibling.focus();
      }
    }

    function handleArrowLeft(e) {
      const previousInput = e.target.previousElementSibling;
      if (!previousInput) return;
      previousInput.focus();
    }

    function handleArrowRight(e) {
      const nextInput = e.target.nextElementSibling;
      if (!nextInput) return;
      nextInput.focus();
    }

    $(inputs).on('input', handleInput);
    inputs[0].addEventListener('paste', handlePaste);

    inputs.forEach((input) => {
      input.addEventListener('focus', (e) => {
        setTimeout(() => {
          e.target.select();
        }, 0);
      });

      input.addEventListener('keydown', (e) => {
        switch (e.keyCode) {
          case KEYBOARDS.backspace:
            handleBackspace(e);
            break;
          case KEYBOARDS.arrowLeft:
            handleArrowLeft(e);
            break;
          case KEYBOARDS.arrowRight:
            handleArrowRight(e);
            break;
          default:
        }
      });
    });
  }
})();

// Exibe o domínio ao digitar o nome da loja
(function () {
  'use strict';

  const $campoSubdominio = $('#form-cadastro #subdominio');
  const $dominioView = $('#form-cadastro .dominio-cad');

  $campoSubdominio.on('input', handleSubdominioCad);

  /* if ($campoSubdominio.length > 0) {
    handleSubdominioCad();
  } */

  function handleSubdominioCad() {
    const nomeLoja = $campoSubdominio.val();
    let subdominioLoja = slugify(nomeLoja);
    if (subdominioLoja != '') {
      $dominioView.html('<b class="text-secondary">Domínio grátis:</b> ' + subdominioLoja + '<b>.lpqv.io</b>');
    } else {
      $dominioView.html('');
    }
  }
})();
